'use client';

import { useAction, useMutation } from 'convex/react';
import { api } from '@/convex/_generated/api';
import { voiceTranscriptApi } from '@/lib/your-imai-voice-history-api';

export function useRealtimeVoiceBackendActions() {
  return {
    appendTranscript: useMutation(voiceTranscriptApi.append),
    createSession: useAction(api.voice.realtime.createRealtimeSession),
    reportLiveUsage: useAction(api.voice.live.reportLiveUsage),
    heartbeatLease: useMutation(
      api.voice.realtime_provider_state.heartbeatRealtimeVoiceSession
    ),
    endLease: useMutation(
      api.products.ai.lib.voice_agent_bridge_queries.endRealtimeVoiceSession
    ),
    getDispatchContext: useAction(api.voice.realtime.getRealtimeChatContext),
    answerDispatchQuestion: useAction(
      api.voice.realtime_dispatch_question.answer
    ),
    getChatContext: useAction(api.voice.realtime.getRealtimeChatContext),
    sendChatMessage: useAction(api.voice.realtime_thread_messaging.send),
    getOffPageQuestion: useAction(
      api.voice.realtime_pending_question.getOffPageQuestion
    ),
    runNativeWebSearch: useAction(api.voice.realtime.runNativeWebSearch),
    runQuickResearch: useAction(api.voice.realtime.runQuickResearch),
    answerAskQuestion: useAction(
      api.products.ai.actions.answer_ask_question.answerAskQuestion
    ),
    answerAskQuestionGroup: useAction(
      api.products.ai.actions.answer_ask_question.answerAskQuestionGroup
    ),
  };
}
